import { jsx as _jsx } from "react/jsx-runtime";
import { RenewSessionModal } from '@components';
const SessionExpiredModal = ({ isOpen, onClose }) => (_jsx(RenewSessionModal, { isOpen: isOpen, onClose: onClose, title: "Por inactividad, tu sesi\u00F3n ha expirado", description: "Reactiva tu sesi\u00F3n para continuar explorando." }));
export default SessionExpiredModal;
